/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAppAction } from "../appAction";
import { userActions } from "./user-action";
import { getDefaultUserState, ICurrentUser, IUserState } from "./user-state";
import { INiche, IUserSettings } from "../../services/types";

const handlers = {
  [userActions.FETCH_CURRENT_USER]: (
    state: IUserState
  ): IUserState => {
    return { ...state,
      loadingUser: true };
  },

  [userActions.FETCH_CURRENT_USER_SUCCESS]: (
    state: IUserState,
    payload: ICurrentUser
  ): IUserState => {
    return { ...state,
      loadingUser: false,
      currentUser: payload };
  },

  [userActions.FETCH_CURRENT_USER_ERROR]: (
    state: IUserState,
    payload: Error
  ): IUserState => {
    return { ...state,
      loadingUser: false,
      userLoginError: payload };
  },

  [userActions.CLEAR_CURRENT_USER]: (
    state: IUserState
  ): IUserState => {
    return { ...state,
      loadingUser: false,
      userLoginError: null,
      likedGifs: [],
      currentUser: {} as ICurrentUser };
  },

  [userActions.FETCH_LIKED_GIFS]: (
    state: IUserState
  ): IUserState => {
    return { ...state, loadingLikedGifs: true };
  },

  [userActions.FETCH_LIKED_GIFS_SUCCESS]: (
    state: IUserState,
    likedGifs: any
  ): IUserState => {
    return { ...state, loadingLikedGifs: false, likedGifs: likedGifs };
  },

  [userActions.FETCH_LIKED_GIFS_ERROR]: (
    state: IUserState,
  ): IUserState => {
    return { ...state, loadingUserContent: false };
  },

  [userActions.UPDATE_USER_PROFILE]: (
    state: IUserState,
  ): IUserState => {
    return { ...state, loadingUser: true };
  },

  [userActions.UPDATE_USER_PROFILE_SUCCESS]: (
    state: IUserState
  ): IUserState => {
    return { ...state, loadingUser: false };
  },

  [userActions.UPDATE_USER_PROFILE_ERROR]: (
    state: IUserState
  ): IUserState => {
    return { ...state, loadingUser: false };
  },

  [userActions.UPDATE_USER_SETTINGS]: (
    state: IUserState,
  ): IUserState => {
    return { ...state, updatingUserSettings: true };
  },

  [userActions.UPDATE_USER_SETTINGS_SUCCESS]: (
    state: IUserState,
    payload: IUserSettings,
  ): IUserState => {
    const currentUser = {
      ...state.currentUser,
      settings: payload
    };

    return { ...state, currentUser, updatingUserSettings: false };
  },

  [userActions.UPDATE_USER_SETTINGS_ERROR]: (
    state: IUserState
  ): IUserState => {
    return { ...state, updatingUserSettings: false };
  },

  [userActions.DELETE_MY_ACCOUNT]: (
    state: IUserState
  ): IUserState => {
    return { ...state };
  },

  [userActions.UPDATE_PROFILE_PHOTO]: (
    state: IUserState
  ): IUserState => {
    return { ...state };
  },

  [userActions.FETCH_MY_NICHES]: (
    state: IUserState
  ): IUserState => {
    return {
      ...state,
      loadingMyNiches: true,
    };
  },

  [userActions.FETCH_MY_NICHES_SUCCESS]: (
    state: IUserState,
    payload: INiche[]
  ): IUserState => {
    return {
      ...state,
      loadingMyNiches: false,
      myNiches: payload
    };
  },

  [userActions.FETCH_MY_NICHES_ERROR]: (
    state: IUserState,
    payload: Error
  ): IUserState => {
    return {
      ...state,
      loadingMyNiches: false,
      myNichesError: payload
    };
  },
};

const userReducer = (
  state: IUserState = getDefaultUserState(),
  action: IAppAction
) => {
  return Object.prototype.hasOwnProperty.call(handlers, action.type) ?
    handlers[action.type](state, action.payload) : state;
};

export default userReducer;
